export default __webpack_public_path__ + "static/media/jntua-o-a.84e7a095.jpg";